export default __webpack_public_path__ + "static/media/1068.eb9d61ba.png";